<bl-modal-content #content
  [title]="'画面動作設定'"
>
  <div body>
    <div class="contents">
      <div class="setting-item setting-item--explanation">
        画面を開いた時に表示するタブを選択してください。
      </div>
      <div class="setting-item">
        <div class="setting-item__label">
          <label>初期表示タブ</label>
        </div>
        <div class="setting-item__input">
          <bl-radio-group
            #firstViewTab
            [(value)]="_screenActionSetting && _screenActionSetting.firstViewTabDiv"
            groupType="inline"
            [items]="_firstViewTabItems"
          ></bl-radio-group>
        </div>
      </div>
      <div class="setting-item setting-item--explanation">
        「ご案内中・印刷済み、すべて表示」タブの検索結果の表示順を選択してください。
      </div>
      <div class="setting-item">
        <div class="setting-item__label">
          <label>初期ソート順</label>
        </div>
        <div class="setting-item__input">
          <bl-radio-group
            #initialSortOrder
            [(value)]="_screenActionSetting && _screenActionSetting.initialSortOrderDiv"
            groupType="inline"
            [items]="_initialSortOrderItems"
          ></bl-radio-group>
        </div>
      </div>
      <div class="setting-item setting-item--notice">
        ※画面動作設定はご利用のアカウントごとに保存されます。<br>
        ※初期ソート順を変更すると画面がリロードされます。
      </div>
    </div>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/sales-slip-search-screen-action-setting-modal/sales-slip-search-screen-action-setting-modal.component.html